import { WorkflowArea } from '../enums/workflow-area.enum';

export interface CreateTaskRequestDto {
    sectionId: string;
    description: string;
    assignedTo: string | null;
    area: WorkflowArea;
    taskType: TaskType;
    dueDate: Date | null;
}
